import React from 'react';

const HSALogo = ({ variant = "primary", className = "w-full h-full", size = "default" }) => {
  const sizeClasses = {
    small: "w-24 h-10",
    default: "w-36 h-14", 
    large: "w-48 h-20",
    xlarge: "w-44 h-16"
  };

  const variants = {
    primary: (
      <img 
        src="https://nnbjrtbvjmkzkwdgklde.supabase.co/storage/v1/object/public/brand-videos/High%20selection%20auto%20logo%20font-04.png" 
        alt="HSA - High Selection Auto" 
        className={`${sizeClasses[size]} ${className} object-contain brightness-100 `}
      />
    ),
    brandmark: (
      <img 
        src="https://nnbjrtbvjmkzkwdgklde.supabase.co/storage/v1/object/public/brand-videos/High%20selection%20auto%20logo%20font-04.png" 
        alt="HSA - High Selection Auto" 
        className={`${sizeClasses[size]} ${className} object-contain brightness-100 `}
      />
    ),
    submark: (
      <img 
        src="https://nnbjrtbvjmkzkwdgklde.supabase.co/storage/v1/object/public/brand-videos/High%20selection%20auto%20logo%20font-04.png" 
        alt="HSA - High Selection Auto" 
        className={`${sizeClasses[size]} ${className} object-contain brightness-100 `}
      />
    )
  };

  return variants[variant] || variants.primary;
};

export default HSALogo;
